/**
 * Codici ATECO comuni per il regime forfettario
 * con relativi coefficienti di redditività
 */

export const ATECO_CODES = [
  {
    code: "62.01",
    label: "Sviluppo software",
    coefficient: 0.67,
  },
  {
    code: "62.02",
    label: "Consulenza informatica",
    coefficient: 0.67,
  },
  {
    code: "63.11",
    label: "Elaborazione dati e hosting",
    coefficient: 0.67,
  },
  {
    code: "69.10",
    label: "Attività degli studi legali",
    coefficient: 0.78,
  },
  {
    code: "69.10.10",
    label: "Avvocati",
    coefficient: 0.78,
  },
  {
    code: "69.20",
    label: "Commercialisti e consulenti del lavoro",
    coefficient: 0.78,
  },
  {
    code: "70.22",
    label: "Consulenza imprenditoriale",
    coefficient: 0.78,
  },
  {
    code: "71.11.00",
    label: "Attività degli architetti",
    coefficient: 0.78,
  },
  {
    code: "71.12",
    label: "Ingegneria e architettura",
    coefficient: 0.78,
  },
  {
    code: "73.11",
    label: "Agenzie pubblicitarie",
    coefficient: 0.78,
  },
  {
    code: "74.10",
    label: "Design e comunicazione visiva",
    coefficient: 0.78,
  },
  {
    code: "74.30",
    label: "Traduzione e interpretariato",
    coefficient: 0.78,
  },
  {
    code: "74.90.99",
    label: "Altre attività professionali",
    coefficient: 0.78,
  },
  {
    code: "85.59",
    label: "Formazione e corsi",
    coefficient: 0.78,
  },
  {
    code: "86.90.29",
    label: "Altre attività paramediche",
    coefficient: 0.78,
  },
  {
    code: "47.91.10",
    label: "E-commerce",
    coefficient: 0.40,
  },
  {
    code: "56.10",
    label: "Ristorazione",
    coefficient: 0.40,
  },
  {
    code: "41.20",
    label: "Costruzione edifici",
    coefficient: 0.86,
  },
  {
    code: "43.21",
    label: "Installazione impianti elettrici",
    coefficient: 0.86,
  },
  {
    code: "49.41",
    label: "Trasporto merci su strada",
    coefficient: 0.67,
  },
];

/**
 * Tipi di contribuzione INPS
 * Nota: le aliquote sono dinamiche per anno, vedi src/constants/aliquote.js
 */
export const INPS_TYPES = [
  {
    id: "gestione-separata",
    label: "Gestione Separata",
    description: "Per professionisti senza cassa previdenziale",
  },
  {
    id: "artigiani",
    label: "Artigiani",
    description: "Per iscritti alla gestione artigiani INPS",
  },
  {
    id: "commercianti",
    label: "Commercianti",
    description: "Per iscritti alla gestione commercianti INPS",
  },
];

/**
 * Aliquote imposta sostitutiva forfettario
 */
export const TAX_RATES = [
  {
    value: 5,
    label: "5% (startup)",
    description: "Aliquota ridotta per i primi 5 anni di attività",
  },
  {
    value: 15,
    label: "15% (standard)",
    description: "Aliquota ordinaria del regime forfettario",
  },
];

/**
 * Soglia massima fatturato regime forfettario
 */
export const FORFETTARIO_THRESHOLD = 85000;

// Soglia di decadenza immediata dal forfettario (uscita nell'anno stesso + IVA).
export const FORFETTARIO_THRESHOLD_EXIT = 100000;
